export const CLASS_NAME = 'cst-line-chart'
export const PATH_ELEMENT_CLASS_NAME = `${CLASS_NAME}-path-element`
